<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  assistanceOutcomeOptions: { type: Array, default: () => [] },
  isRecordingAssistanceOutcome: { type: Boolean, default: false },
  canRecordAssistanceOutcome: { type: Boolean, default: false },
});

const emit = defineEmits(['submit']);

const assistanceOutcomeForm = defineModel({ type: Object, required: true });

const { t } = useI18n();
</script>

<template>
  <form
    class="grid gap-3 rounded-lais border border-lais-border-soft bg-lais-bg px-3 py-3"
    @submit.prevent="emit('submit')"
  >
    <p class="text-[12px] font-semibold text-lais-text">
      {{ t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.TITLE') }}
    </p>
    <div class="grid gap-3 sm:grid-cols-2">
      <LaisField :label="t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.RESULT')">
        <select
          v-model="assistanceOutcomeForm.resolution_outcome"
          class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
        >
          <option
            v-for="item in assistanceOutcomeOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </LaisField>
      <LaisField :label="t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.SCORE')">
        <input
          v-model.trim="assistanceOutcomeForm.satisfaction_score"
          type="number"
          min="1"
          max="5"
          step="1"
          class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
        />
      </LaisField>
    </div>
    <LaisField :label="t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.COMMENT')">
      <textarea
        v-model.trim="assistanceOutcomeForm.satisfaction_comment"
        rows="2"
        class="min-h-[72px] resize-y rounded-lais border border-lais-border bg-white px-3 py-2 text-[14px] text-lais-text outline-none focus:border-lais-primary"
      />
    </LaisField>
    <div class="grid gap-3 sm:grid-cols-2">
      <label class="flex items-center gap-2 text-[12px] text-lais-text">
        <input
          v-model="assistanceOutcomeForm.recurrence"
          type="checkbox"
          class="rounded border-lais-border"
        />
        <span>{{ t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.RECURRENCE') }}</span>
      </label>
      <label class="flex items-center gap-2 text-[12px] text-lais-text">
        <input
          v-model="assistanceOutcomeForm.close_ticket"
          type="checkbox"
          class="rounded border-lais-border"
        />
        <span>{{ t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.CLOSE_TICKET') }}</span>
      </label>
    </div>
    <LaisField
      v-if="assistanceOutcomeForm.recurrence"
      :label="t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.RECURRENCE_REASON')"
    >
      <input
        v-model.trim="assistanceOutcomeForm.recurrence_reason"
        type="text"
        class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
      />
    </LaisField>
    <div class="grid gap-2 text-[12px] text-lais-text">
      <label class="flex items-center gap-2">
        <input
          v-model="assistanceOutcomeForm.follow_up_required"
          type="checkbox"
          class="rounded border-lais-border"
        />
        <span>{{ t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.FOLLOW_UP') }}</span>
      </label>
      <label class="flex items-center gap-2">
        <input
          v-model="assistanceOutcomeForm.cost_disputed"
          type="checkbox"
          class="rounded border-lais-border"
        />
        <span>{{ t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.COST_DISPUTED') }}</span>
      </label>
    </div>
    <p class="text-[11px] leading-5 text-lais-text-muted">
      {{ t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.FINANCE_NOTE') }}
    </p>
    <div class="flex justify-end">
      <LaisPrimaryButton
        type="submit"
        icon="i-lucide-clipboard-check"
        variant="ghost"
        :is-loading="isRecordingAssistanceOutcome"
        :disabled="!canRecordAssistanceOutcome"
      >
        {{ t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.SUBMIT') }}
      </LaisPrimaryButton>
    </div>
  </form>
</template>
